import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div id="second-factor">
  <h3>{{this.secondFactorTitle}}</h3>
  {{#if this.optionalText}}
    <p>{{html-safe this.optionalText}}</p>
  {{/if}}
  <p>{{this.secondFactorDescription}}</p>
  {{yield}}
  {{#if this.showToggleMethodLink}}
    <p>
      <a
        href
        class="toggle-second-factor-method"
        {{on "click" this.toggleSecondFactorMethod}}
      >{{i18n this.linkText}}</a>
    </p>
  {{/if}}
</div>
*/
{
  "id": "Dk0RIaVF",
  "block": "[[[10,0],[14,1,\"second-factor\"],[12],[1,\"\\n  \"],[10,\"h3\"],[12],[1,[30,0,[\"secondFactorTitle\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"optionalText\"]],[[[1,\"    \"],[10,2],[12],[1,[28,[35,1],[[30,0,[\"optionalText\"]]],null]],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,2],[12],[1,[30,0,[\"secondFactorDescription\"]]],[13],[1,\"\\n  \"],[18,1,null],[1,\"\\n\"],[41,[30,0,[\"showToggleMethodLink\"]],[[[1,\"    \"],[10,2],[12],[1,\"\\n      \"],[11,3],[24,6,\"\"],[24,0,\"toggle-second-factor-method\"],[4,[38,3],[\"click\",[30,0,[\"toggleSecondFactorMethod\"]]],null],[12],[1,[28,[35,4],[[30,0,[\"linkText\"]]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"&default\"],false,[\"if\",\"html-safe\",\"yield\",\"on\",\"i18n\"]]",
  "moduleName": "discourse/components/second-factor-form.hbs",
  "isStrictMode": false
});